import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon ,MDBRow, MDBCol,MDBDataTable    } from 'mdbreact';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';
import Axios from 'axios'

import adminfaculty from '../adminfaculty/adminfaculty';
//import Modalarticletyps from './Modalarticletypes';
import { URL,api } from '../../api';
import Modaladdexpert from './Modaladdexpert';
import Modaleditexpert from './Modaleditexpert';
import Modaladdroompresent from '../Modaladdroompresent';
import Modaladdarticalpresent from '../Modaladdarticalpresent';
import Modaladdexperpresent from '../Modaladdexperpresent';
import Modaladdroompresentsm from '../Modaladdroompresentsm';
import Modaladdarticalpresentsm from '../Modaladdarticalpresentsm';
import Modaladdexperpresentsm from '../Modaladdexperpresentsm';





export default class Superadminroompresentsm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[]
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.list = this.list.bind(this);
      }


    componentDidMount() {
        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
          api.get('registercon/selectroompresentlistsm')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      list() {

        setTimeout(() => {
          api.get('registercon/selectroompresentlistsm')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectregisterall')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }

      printname(){
        // window.location.href = 'http://localhost/conferencekpru/report/reportregistergroup.php'
        // window.open(
        //   'http://localhost/conferencekpru/report/reportregistergroup.php?type='+this.props.id_typeregister+'&namegroup='+this.props.name_typeregister,
        //   '_blank' // <- This is what makes it open in a new window.
        // );
        
        // window.open(
        //   'https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/report/reportregistergroup.php?type='+this.props.id_typeregister+'&namegroup='+this.props.name_typeregister,
        //   '_blank' 
        // );
      }



    render() {


      const datast = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'หมายเลขห้อง',
            field: 'name_expert',
            sort: 'name_expert',
            width: 150
          },
          {
            label: 'วันที่นำเสนอ',
            field: 'roompresent_date',
            sort: 'roompresent_date	',
            width: 150
          },
          {
            label: 'จัดการบทความ',
            field: 'password_expert',
            sort: 'password_expert',
            width: 150
          },
         
          {
            label: 'จัดการผู้ทรงคุณวุฒิ',
            field: 'name_admin2',
            sort: 'name_admin2',
            width: 150
          },
          {
            label: 'พิมพ์ชื่อบทความ',
            field: 'print',
            sort: 'print',
            width: 150
          },
          
      
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
          {
             list: <>{i+1}</>,
             name_expert: <>{data.name_room}</>,
             roompresent_date	: <>{data.roompresent_datesm}</>,
             password_expert: <><Modaladdarticalpresentsm id_roompresent={data.id_roompresentsm} name_room={data.name_room}	 roompresent_date={data.roompresent_datesm}	/></>,
             name_admin2: <><Modaladdexperpresentsm id_roompresent={data.id_roompresentsm} name_room={data.name_room}	 roompresent_date={data.roompresent_datesm} /></>,
             print: <><a href={`http://localhost/conferencekpru/report/reportarticlemaproom.php?id_roompresent=${data.id_roompresent}&name_room=${data.name_room}`}  target="_blank" > <MDBBtn color="mdb-color" size='sm'>พิมพ์</MDBBtn></a></>,
            //  name_admin2: <><Modaleditexpert id_expert={data.id_expert} list={this.list} /></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
            theadColor="grey lighten-1"
            />

        return (
            <MDBContainer fluid>
            <div>
        
            {localStorage.getItem('admin_type') === 'expertbn' ?<>
              <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (บรรณาธิการ)</p>
             </>:<>
              <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
             </>}
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 3 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
               <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}    
                    <MDBRow >
                        <MDBCol md="8">
                        <PageHeader
                            className="site-page-header"
                          // onBack={() => null}
                            title="เพิ่มข้อมูลห้องนำเสนอ ประเภทสัมมนา"
                            subTitle="ข้อมูลห้องนำเสนอ ประเภทสัมมนา"
                            avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                        />
                        </MDBCol>
                        <MDBCol md="4">
                        <Modaladdroompresentsm iduser={localStorage.getItem('iduser')} list={this.list} />
                        </MDBCol>
                    </MDBRow>
   </MDBAlert>
    {persons}
{/*    
 
                <MDBTable responsive>
                    <MDBTableHead color='light'>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อ-นามสกุล</th>
                        <th>Username</th>
                        <th>Password</th>
                        <th>สังกัดหน่วยงาน</th>
                        <th>ความเชียวชาญ</th>
                        <th>เบอร์โทร</th>
                        <th>ผู้เพิ่มข้อมูล</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.name_expert}</td>
                        <td>{article.username_expert}</td>
                        <td>{article.password_expert}</td>
                        <td>{article.affiliation_expert}</td>
                        <td>{article.expertise_expert}</td>
                        <td>{article.tel_expert}</td>
                        <td>{article.name_admin}</td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
